module.exports = __webpack_public_path__ + "img/win-4.30fa8bf8.webp";